import { defineMessages } from 'react-intl';

const messages = defineMessages({
    recommendedSuggestions: {
        id:'recommendedSuggestions',
        defaultMessage: 'Recommended suggestions',
        description: 'Label that goes on top of recommended suggestions list on search pages.',
    },
});

export default messages;
